import React from 'react';
import './LegalNotices.css'; 

const LegalNotices = () => {
  return (
    <div className="legal-notices-container">
      <h1 className="legal-title">LEGAL NOTICES</h1>
      <p className="date">Last Updated: March 6, 2025</p>
      <p className="intro">
        Welcome to ClientBloom.ai. The services on our site are provided by Client Bloom LLC, a limited liability company formed in Wyoming. These legal notices govern your use of our platform, including our Terms of Use, Privacy Policy, Disclaimer, and SaaS-Specific Provisions. By accessing or using our services, you agree to be bound by these terms. If you do not agree, do not use our services.
      </p>
      
      <section>
        <h2>1. TERMS OF USE</h2>
        <h3>1.1. Acceptance of Terms</h3>
        <p>
          By using the Client Bloom platform, website, or related services, you acknowledge that you have read, understood, and agreed to these Terms of Use. Your continued use of our services constitutes your acceptance of these terms in their entirety. If you do not agree, you should discontinue use immediately.
        </p>

        <h3>1.2. Access and Authorized Use</h3>
        <p>
          Your access to and use of our services is conditional upon compliance with these Terms. We grant you a limited, non-exclusive, non-transferable, and revocable license to use our platform in accordance with these Terms.
        </p>

        <h3>1.3. Payments, Subscriptions, and Cancellations</h3>
        <p>
          Our platform operates on a subscription-based model, with payments securely processed through Stripe. Subscription fees are charged in advance and will continue on a recurring basis until canceled.
        </p>

        <h3>1.4. Service Availability and Modifications</h3>
        <p>
          We strive to maintain 99.9 percent uptime for our services, but we do not guarantee uninterrupted or error-free operation. There may be instances where our platform is temporarily unavailable due to maintenance, technical issues, or circumstances beyond our control.
        </p>

        <h3>1.5. Termination and Account Deletion</h3>
        <p>
          We reserve the right to suspend or terminate your account if we determine that you have violated these Terms, engaged in fraudulent or illegal activity, or acted in a manner that disrupts the integrity of our platform.
        </p>

        <h3>1.6. Intellectual Property Rights</h3>
        <p>
          All content, software, trademarks, and branding associated with our platform are the exclusive property of Client Bloom or its licensors.
        </p>

        <h3>1.7. Dispute Resolution and Governing Law</h3>
        <p>
          These Terms shall be governed by and construed in accordance with the laws of the State of Wyoming, without regard to conflicts of law principles. Any disputes arising from or related to these Terms shall be resolved through binding arbitration in Wyoming.
        </p>
      </section>

      <section>
        <h2>2. PRIVACY POLICY</h2>
        <h3>2.1. Information We Collect</h3>
        <p>
          We collect personal and usage data necessary for providing and improving our services. This includes account registration details, payment information, device and browser details, and interactions with our platform.
        </p>

        <h3>2.2. How We Use Your Information</h3>
        <p>
          Your information is used to operate and improve our services, process transactions, prevent fraud, and communicate updates.
        </p>

        <h3>2.3. Data Sharing and Third-Party Services</h3>
        <p>
          We do not sell or rent your data. However, we may share information with third-party service providers, such as Stripe for payment processing.
        </p>

        <h3>2.4. Your Rights and Data Retention</h3>
        <p>
          Depending on your jurisdiction, you may have rights regarding access, correction, and deletion of your data.
        </p>
      </section>

      <section>
        <h2>3. DISCLAIMER</h2>
        <h3>3.1. No Guarantees or Warranties</h3>
        <p>
          Our platform is provided on an “as is” and “as available” basis. We make no representations or warranties regarding the reliability, accuracy, or suitability of our services.
        </p>

        <h3>3.2. AI and Machine Learning Disclaimer</h3>
        <p>
          If our platform includes AI-powered features, the results generated by AI are for informational purposes only.
        </p>

        <h3>3.3. External Links and Third-Party Services</h3>
        <p>
          Our website may contain links to third-party services. We are not responsible for their content or practices.
        </p>

        <h3>3.4. Limitation of Liability</h3>
        <p>
          To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, or consequential damages arising from your use of our platform.
        </p>
      </section>

      <section>
        <h2>4. CONTACT INFORMATION</h2>
        <p>
          For legal or privacy-related inquiries, you may contact us at:
        </p>
        <address>
          Client Bloom LLC<br />
          30 N Gould St Ste R<br />
          Sheridan, WY 82801<br />
          Email: hello@clientbloom.ai
        </address>
      </section>

      <p className="final-note">
        By using our services, you confirm that you have read, understood, and agreed to these legal notices.
      </p>
    </div>
  );
};

export default LegalNotices;
